import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from '../../Redux/apiSlice';

const DESIGNER_LIST_URL = `${API_URL}/designer/list`;
const DESIGNER_DELETE_URL = `${API_URL}/designer`;

const DesignerList = () => {
  const [designers, setDesigners] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAuthHeader = () => {
    try {
      const raw = localStorage.getItem("knighthuntToken") || "";
      const token = raw.trim();
      if (!token) return null;
      return token.toLowerCase().startsWith("bearer ")
        ? token
        : `Bearer ${token}`;
    } catch {
      return null;
    }
  };

  // Fetch list
  const fetchDesigners = async () => {
    try {
      setLoading(true);

      const auth = getAuthHeader();

      const resp = await fetch(DESIGNER_LIST_URL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(auth ? { Authorization: auth } : {}),
        },
        credentials: "include",
      });

      const data = await resp.json();
      const list = data?.response || [];

      setDesigners(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error("Fetch designers error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Delete using param not body
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this designer?")) return;

    try {
      const auth = getAuthHeader();

      const resp = await fetch(`${DESIGNER_DELETE_URL}/${id}`, {
        method: "DELETE",
        headers: {
          ...(auth ? { Authorization: auth } : {}),
        },
        credentials: "include",
      });

      const data = await resp.json();

      if (data?.status) {
        alert("Designer deleted successfully!");
        fetchDesigners();
      } else {
        alert(data?.message || "Failed to delete designer.");
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("Error while deleting (check console).");
    }
  };

  // Load on mount
  useEffect(() => {
    fetchDesigners();
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="page-content">
      <h3>Designer List</h3>

      <Link to="/designer-create" className="btn btn-primary mb-3">
        Add Designer
      </Link>

      <table className="table align-middle">
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Gender</th>
            <th>Address</th>
            <th>Pic</th>
            <th>Portfolio</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {designers.length === 0 ? (
            <tr>
              <td colSpan={7} className="text-center text-muted">
                No designers found
              </td>
            </tr>
          ) : (
            designers.map((designer) => (
              <tr key={designer.id}>
                <td style={{ fontWeight: "600" }}>{designer.name}</td>

                <td>{designer?.category?.name || "-"}</td>

                <td>{designer.gender || "-"}</td>

                <td>{designer.address || "-"}</td>

                <td>
                  {designer.pic ? (
                    <img
                      src={designer.pic}
                      alt={designer.name}
                      style={{
                        width: 64,
                        height: 64,
                        objectFit: "cover",
                        borderRadius: 6,
                        border: "1px solid #ddd",
                      }}
                    />
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  {designer.portfolio ? (
                    <a
                      href={designer.portfolio}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  <Link
                    to={`/designer-edit/${designer.id}`}
                    className="btn btn-sm btn-warning me-2"
                  >
                    Edit
                  </Link>

                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(designer.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DesignerList;
